import React from 'react';
import PropTypes from 'prop-types';

import FilledButton from 'components/Buttons/FilledButton';
import Overlay from 'components/Informations/Overlay';

import { logout } from 'services/auth';

const NotAllowed = ({ history }) => {
  const acceptAndLogout = () => {
    logout();
    return history.push('/Login');
  };

  return (
    <Overlay
      isOpen
      type="information"
      text={[
        'Você ',
        <span>não está cadastrado</span>,
        ' no Sagitário, contate o seu gestor imediato.',
      ]}
    >
      <FilledButton text="Ok" handleClick={acceptAndLogout} />
    </Overlay>
  );
};

export default NotAllowed;

NotAllowed.defaultProps = {
  history: {},
};

NotAllowed.propTypes = {
  history: PropTypes.shape(
    PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  ),
};
